export const environment = {
  production: true,
  demoServer: "https://demo.ticketsystem.app/api/",
  version: "1.13.1",
  compatible_server_versions: ["1.13.1"],
  sentryUrl: "https://cb514d9568b662e65352f59741b4c792@o4508137360785408.ingest.de.sentry.io/4508142635188304",
  stripeInformationURL: "https://billing.stripe.com/p/login/aEU8yRfi91Rt5Ec6oo",
  stripeSubItems: [
    {
      id: "price_1MqbAjBuURQQysKhfcsBnCEd",
      description: "Ohne Kundenanmeldung",
      icon: "fa-ticket",
      withCustomerLogin: false,
      name: "Basic"
    },
    {
      id: "price_1MqbEcBuURQQysKhIZiTykTB",
      description: "Mit Kundenanmeldung",
      withCustomerLogin: true,
      icon: "fa-stars",
      name: "Premium"
    },
  ]
};